<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      :label-position="labelPosition"
      :label-width="labelWidth"
      :size="size"
    >
      <el-form-item
        v-for="(item, index) in ruleData"
        :key="index"
        :label="item.label"
        :prop="item.prop || ''"
        :class="item.class"
        v-show="!item.hidden"
      >
        <template slot-scope="scope">
          <template v-if="item.type === 'input'">
            <el-input
              v-if="item.clickFunc"
              :type="item.inputText || 'text'"
              :readonly="item.readonly || false"
              @click.native="item.clickFunc"
              :class="item.clickFunc ? 'pointer' : ''"
              :ref="item.ref"
              v-model="ruleForm[item.prop]"
              @input="update($event)"
            >
            </el-input>
            <el-input
              v-else
              :type="item.inputText || 'text'"
              :readonly="item.readonly || false"
              :disabled="item.disabled || false"
              v-model="ruleForm[item.prop]"
              :maxlength="item.maxlength"
              :minlength="item.minlength"
              :show-password="item.showPassword || false"
              :clearable="item.clearable"
              :show-word-limit="item.showWordLimit || false"
            >
            </el-input>
          </template>
          <template v-else-if="item.type == 'select'">
            <el-select
              v-if="item.visibleFunc"
              v-model="ruleForm[item.prop]"
              :placeholder="item.placeholder || '请选择'"
              :filterable="item.filterable  || false"
              @change="selectChange"
              @visible-change="item.visibleFunc"
            >
              <el-option
                v-for="i in item.options"
                :key="i[item.value] || i.value"
                :label="i[item.key] || i.label"
                :value="i[item.value] || i.value"
                :disabled="i.disabled"
              >
              </el-option>
            </el-select>
            <el-select
              v-else
              v-model="ruleForm[item.prop]"
              :placeholder="item.placeholder || '请选择'"
              :filterable="item.filterable  || false"
              @change="selectChange"
            >
              <el-option
                v-for="i in item.options"
                :key="i[item.value] || i.value"
                :label="i[item.key] || i.label"
                :value="i[item.value] || i.value"
                :disabled="i.disabled"
              >
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.type === 'switch'">
            <el-switch
              v-model="ruleForm[item.prop]"
              :active-text="item.activeText || '开'"
              :inactive-text="item.inactiveText || '关'"
            ></el-switch>
          </template>
          <template v-else-if="item.type === 'radio'">
            <el-radio-group
              @change="radioChange($event,item.prop)"
              v-model="ruleForm[item.prop]"
              :disabled="item.disabled"
            >
              {{ruleForm[item.prop]}}
              <el-radio
                v-for="(child,childIndex) in item.children"
                :key="childIndex"
                :label="childIndex"
              >{{child}}</el-radio>
            </el-radio-group>
            <el-select
              v-if="item.hasSelect"
              v-model="ruleForm[item.prop]"
              :placeholder="item.placeholder || '请选择'"
              @change="selectChange"
            >
              <el-option
                v-for="i in item.options"
                :key="i[item.value] || i.value"
                :label="i[item.key] || i.label"
                :value="i[item.value] || i.value"
                :disabled="i.disabled"
              >
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.type == 'customize'">
            <slot
              :scope="scope"
              :name="item.slotName"
            >
            </slot>
          </template>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'rule-form',
  data() {
    return {
      // labelPosition: 'left'
    }
  },
  props: {
    // 表单数据
    ruleData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表单model
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 表单验证规则
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 标签位置
    labelPosition: {
      type: String,
      default: 'right'
    },
    size: {
      type: String,
      default: 'small'
    },
    labelWidth: {
      type: String,
      default: '100px'
    }
  },
  mounted() {
  },
  methods: {
    selectChange(val) {
      this.$emit('selectChange', val)
    },
    radioChange(event, prop) {
      this.$emit('radioChange', event, prop)
    },
    update(e) {
      this.$forceUpdate()
    }
  }
}
</script>
<style>
.pointer input {
  cursor: pointer;
}
</style>